<script setup lang="ts">
import { onMounted, ref, toRefs } from 'vue';

import type { SymbolDTO, SymbolPackDTO } from '@nora-monorepo/nora-api-client';

import Symbol from '#nora-ui/map/components/drawtools/symbol-tool/Symbol.vue';
import type { SymbolTool } from '#nora-ui/map/drawtools/symbol-tool/symbol-tool';

interface Props {
  symbolPack: SymbolPackDTO;
  mapId: string;
  tool: SymbolTool;
}

const props = defineProps<Props>();
const { symbolPack, tool } = toRefs(props);

const loadedSymbolPack = ref<SymbolPackDTO | null>(null);

function setSelectedSymbol(symbol: SymbolDTO) {
  tool.value.setSelectedSymbol({
    symbolId: symbol.id,
    symbolPackId: symbol.symbolPackId,
    symbolName: symbol.name,
  });

  tool.value.symbolToolStore.setSelectedSymbol({
    symbolId: symbol.id,
    symbolPackId: symbol.symbolPackId,
    symbolName: symbol.name,
  });
}

onMounted(async () => {
  loadedSymbolPack.value = await tool.value.symbolToolStore.loadSymbolPack(symbolPack.value.id);
});
</script>

<template>
  <div
    v-if="loadedSymbolPack"
    class="grid grid-cols-[repeat(auto-fit,44px)] gap-2 px-2"
  >
    <button
      v-for="symbol in loadedSymbolPack.symbols"
      :key="symbol.id"
      :title="symbol.name ?? ''"
      class="flex overflow-hidden items-center rounded-sm border border-light-separator-no-transparency dark:border-primary-500 justify-center text-center w-11 h-11 cursor-pointer"
      @click="() => setSelectedSymbol(symbol)"
    >
      <Symbol
        :symbol="symbol"
        class="w-full h-full object-contain"
      />
    </button>
  </div>
</template>
